import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { authHeader } from '@/services/auth'
import { formatCodenamesCall, formatFilters } from '@/services/posts'
import axios from 'axios'
import store from '@/store'
import i18next from 'i18next'
import { $t } from '@/i18n'

const baseURL = processEnvConfig.VUE_APP_HYPER_ESPACE_API_URL + '/social-management-posts'

export default {
  namespaced: true,
  state: {
    socialPostsEditoriaux: {
      total: -1,
      list: []
    },
    filters: {
      page: 1,
      limit: 10,
      search: '',
      network: null,
      dateDiff: {
        before: null,
        after: null
      }
    },
    loadingStatus: false,
    modalDelete: false,
    postToDelete: [],
    idsToDelete: [],
    selection: []
  },
  getters: {
    getSocialPostsEditoriaux: (state) => state.socialPostsEditoriaux,
    getPage: (state) => state.filters.page,
    getLimit: (state) => state.filters.limit,
    getLoadingStatus: (state) => state.loadingStatus,
    getPagination: (state) => state.socialPostsEditoriaux.pagination,
    getPostToDelete: (state) => state.postToDelete,
    getModalDelete: (state) => state.modalDelete,
    getTotal: (state) => state.socialPostsEditoriaux.total,
    getSearch: (state) => state.filters.search,
    getNetwork: (state) => state.filters.network,
    getFilters: (state) => state.filters,
    getSelection: (state) => state.selection,
    getIdsToDelete: (state) => state.idsToDelete
  },
  mutations: {
    setSocialPostsEditoriaux (state, payload) {
      state.socialPostsEditoriaux = payload
    },
    setPostsList (state, payload) {
      state.socialPostsEditoriaux.list = payload
    },
    setPage (state, payload) {
      state.filters.page = payload
    },
    setSelection (state, selection) {
      state.selection = selection
    },
    setLimit (state, payload) {
      state.filters.limit = payload
    },
    setLoadingStatus (state, payload) {
      state.loadingStatus = payload
    },
    setPagination (state, payload) {
      state.socialPostsEditoriaux.pagination = payload
    },
    setDateDiff (state, dateDiff) {
      state.filters.dateDiff = dateDiff
    },
    setPostToDelete (state, payload) {
      state.postToDelete = payload
    },
    checkDiffusionsPostsToDelete (state) {
      let posts = []
      state.postToDelete.forEach(function (post) {
        let cpt = 0
        post.diffusions.forEach(function (diffusion) {
          if(diffusion.firstSentAt) {
            cpt = cpt + 1
          }
        })
        if(cpt === 0) {
          posts.push(post)
        }
      })
      state.postToDelete = posts
    },
    setIdsToDelete (state, payload) {
      state.idsToDelete = payload
    },
    setModalDelete (state, modalDelete) {
      state.modalDelete = modalDelete
    },
    setTotal (state, total) {
      state.socialPostsEditoriaux.total = total
    },
    setSearch (state, payload) {
      state.filters.search = payload
    },
    setNetwork (state, network) {
      state.filters.network = network
    }
  },
  actions: {
    loadSocialPostsEditoriaux ({
      commit,
      getters
    }) {
      commit('setLoadingStatus', true)
      const params = {
        headers: authHeader()
      }
      let url = `${baseURL}?universe=EDITO`
      url = url + '&fields=reference,etat,assets,titre,photoPrincipale,facebookCaption,instagramCaption,linkedinCommentary,googleLocalpostSummary'
      url = url + '&champsRechercheLibre[]=titre&champsRechercheLibre[]=reference'
      url = url + '&rechercheLibre=' + getters.getSearch
      url = url + '&etat=A,B'
      const codenamesCall = formatCodenamesCall(null, true, true)

      let codenames = codenamesCall[0]
      if(getters.getNetwork != null && getters.getNetwork !== 'allPosts') {
        codenames = getters.getNetwork
      }
      url = url + '&portalCodesAnnonces=' + codenames
      codenamesCall[1].forEach(function (element) {
        url = url + '&linkedPortals[]=' + element
      })
      if(getters.getNetwork != null && getters.getNetwork !== 'allPosts') {
        url = url + '&annoncesDiffusees=O'
      }
      url = url + '&page=' + getters.getPage
      url = url + '&perPage=' + getters.getLimit

      // Filters => voir pour ajouter les filtres en fonction des datas envoyé
      return HTTP_HYPER_ESPACE_BACKEND
        .get(url)
        .then(response => {
          if (response.data.annonces) {
            const objResponse = {
              total: response.data.total,
              list: response.data.annonces
            }
            commit('setSocialPostsEditoriaux', objResponse)
            commit('setLoadingStatus', false)
          }
        }).catch(error => {
          console.log({ type: 'error', message: error })
          commit('setLoadingStatus', false)
        })
    },
    changeState ({ commit, getters }, post) {
      commit('setLoadingStatus', true)

      let statusToUpdate = ''
      if (post.state === 'B') {
        statusToUpdate = 'A'
      }
      if (post.state === 'A') {
        statusToUpdate = 'B'
      }

      const payload = {
        state: statusToUpdate
      }

      const url = '/annonce' + '/' + post.id

      const updatePost = HTTP_HYPER_ESPACE_BACKEND
        .patch(url, payload)
        .then(_response => {
          return { type: 'success', message: 'OK' }
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
      commit('setLoadingStatus', false)
    },
    exportPostsEditoriaux (context, selectedIds) {
      const sitimmoUser = store.getters.getSitimmoUser

      // vérification de l'email pour l'envoi de l'export
      const hasEmail = sitimmoUser && sitimmoUser.email

      const filters = context.getters.getFilters
      filters.univers = 'EDITO'

      delete filters.page
      delete filters.perPage
      delete filters.limit

      const exportType = 'SOCIAL_POSTS_EDITO'

      const data = {
        filters: filters,
        exportType: exportType,
        to: hasEmail ? sitimmoUser.email : '',
        filename: 'POSTS_EDITO',
        lang: i18next.language
      }

      return HTTP_HYPER_ESPACE_BACKEND
        .post('/export_requests', data)
        .then(response => {
          if (response.status === 202) {
            // Si pas d'email, retourner un message d'avertissement
            if (!hasEmail) {
              return { type: 'warning', message: $t('layouts.exportWarningNoEmail') }
            }
            return { type: 'success', message: $t('layouts.exportSuccess') }
          }
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    deletePostEditorial (context) {
      context.commit('setLoadingStatus', true)
      const params = {
        data: context.getters.getIdsToDelete
      }
      const url = '/annonce'
      HTTP_HYPER_ESPACE_BACKEND
        .delete(url, params)
        .then(response => {
          return { type: 'success', message: 'OK' }
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
        .finally(function () {
          context.dispatch('loadSocialPostsEditoriaux')
          context.commit('setLoadingStatus', false)
          context.commit('setModalDelete', false)
        })
    }
  }
}
